import { useEffect } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { useProjectActions } from 'src/store';

import { LocalStore } from '../store';

const useLocalState = createStateSelectorHook(LocalStore, [
  'briefContent',
  'freestyleToolContent',
  'rewriteText',
]);

export const useSetSuggestedDocumentTitle = () => {
  const projectActions = useProjectActions();
  const { briefContent, freestyleToolContent, rewriteText } = useLocalState();

  useEffect(() => {
    projectActions.setProjectSuggestedTitle(
      briefContent?.title || briefContent?.body || briefContent?.freeText || briefContent?.article
    );
  }, [briefContent, projectActions]);

  useEffect(() => {
    projectActions.setProjectSuggestedTitle(freestyleToolContent.allInstructions);
  }, [freestyleToolContent, projectActions]);

  useEffect(() => {
    const text = `Content improver: ${rewriteText}`;
    projectActions.setProjectSuggestedTitle(text);
  }, [projectActions, rewriteText]);
};
